export default __webpack_public_path__ + "static/media/AboutMe.48fa5bd3.svg";